Object.defineProperty(exports, '__esModule', { value: true });

const svgns = "http://www.w3.org/2000/svg";
const xlinkns = "http://www.w3.org/1999/xlink";

function iconHelper(icon) {
    const svg = document.createElementNS(svgns, 'svg');
    const use = document.createElementNS(svgns, 'use');

    svg.setAttribute('viewBox', '0 0 32 32');
    svg.setAttribute('class', 'icon inline-icon-' + icon);

    use.setAttributeNS(xlinkns, 'href', '/images/icons.svg#' + icon);

    svg.appendChild(use);

    return svg;
}

exports['default'] = iconHelper;